const INIT_STATE = { general: {}, detail: {}, error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_PROFILE_GENERAL_SUCCESS":
      return {
        ...state,
        general: action.payload,
        error: null,
      };
    case "GET_PROFILE_GENERAL_ERROR":
      return { ...INIT_STATE, error: action.payload };
    case "GET_PROFILE_SUCCESS":
      return {
        ...state,
        detail: action.payload,
        error: null,
      };
    case "GET_PROFILE_ERROR":
      return { ...INIT_STATE, error: action.payload };
    default:
      return state;
  }
};
